import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";

import {
  IonIcon,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
  IonProgressBar,
  IonSearchbar,
  isPlatform,
  useIonModal,
  IonImg,
  IonItem,
  IonLabel,
  IonText,
} from "@ionic/react";

import { add, arrowBack } from "ionicons/icons";

import ConversationOutcomeCategoriesListItem from "./components/ConversationOutcomeCategoriesListItem";
import ConversationOutcomeCategoryDetail from "./components/ConversationOutcomeCategoryDetail";
import { SessionContext } from "../../session";

const ConversationOutcomeCategoriesPage: React.FC = observer(() => {
  const [searchText, setSearchText] = useState("");
  const [selectedItem, setSelectedItem] = useState<string>();

  const handleDismiss = () => {
    dismiss();
  };

  const session = useContext(SessionContext);
  if (!session) {
    return <></>;
  }

  const [present, dismiss] = useIonModal(ConversationOutcomeCategoryDetail, {
    category: selectedItem,
    conversationOutcomesSettings: session.conversationOutcomesSettings,
    onDismiss: handleDismiss,
  });

  const categories = session.conversationOutcomesSettings?.categories?.filter(
    (category) =>
      (category ?? "").trim() !== "" &&
      (category ?? "").toUpperCase().includes((searchText ?? "").toUpperCase())
  );

  if (!categories) {
    return <IonProgressBar color="primary" type="indeterminate" />;
  }

  return (
    <IonPage>
      <IonHeader
      //className="ion-no-border"
      >
        <IonToolbar color="primary">
          <IonButtons slot="start">
            {session.windowSize === "small" ? (
              <>
                {/*<IonBackButton defaultHref={`/conversations`}></IonBackButton>*/}
                <IonButton routerLink="/admin">
                  <IonIcon icon={arrowBack} />
                </IonButton>
              </>
            ) : (
              <></>
            )}
          </IonButtons>
          <IonTitle>Conversation Outcome Categories</IonTitle>
          <IonButtons slot="end">
            <IonButton
              shape="round"
              expand="block"
              size="large"
              fill="solid"
              color="light"
              onClick={() => {
                setSelectedItem("");
                present({ cssClass: "modal-create-view" });
              }}
            >
              <IonIcon icon={add} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonProgressBar
          hidden={!session.conversationOutcomesSettings?.loading}
          type="indeterminate"
        />
        <IonSearchbar
          color="light"
          value={searchText}
          onIonChange={(e) => setSearchText(e.detail.value!)}
        ></IonSearchbar>
        <IonList>
          {categories && categories.length > 0
            ? categories.map((item) => (
                <ConversationOutcomeCategoriesListItem
                  key={item}
                  category={item}
                  onSelectItem={(item) => {
                    setSelectedItem(item);
                    present({ cssClass: "modal-edit-view" });
                  }}
                />
              ))
            : (searchText ?? "") !== "" && (
                <IonItem style={{}} lines="none">
                  <IonLabel className="ion-text-center">
                    <IonImg
                      style={{
                        maxWidth: "250px",
                        margin: "auto",
                        marginTop: "69px",
                      }}
                      src={
                        (searchText ?? "") === ""
                          ? "/assets/images/artboard007.png"
                          : "/assets/images/artboard008.png"
                      }
                    />
                    <p>
                      <strong>
                        <IonText
                          color="dark"
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          {(searchText ?? "") === ""
                            ? ""
                            : " No Search Results"}
                        </IonText>
                      </strong>
                    </p>
                    <p
                      style={{
                        marginTop: "5px",
                      }}
                    >
                      <IonText
                        color="medium"
                        style={{
                          fontSize: "16px",
                        }}
                      ></IonText>
                    </p>
                  </IonLabel>
                </IonItem>
              )}
        </IonList>
      </IonContent>
    </IonPage>
  );
});

export default ConversationOutcomeCategoriesPage;
